<template>
  <div class="h5-container">
    <van-nav-bar
        class="top-bar"
        title="我的球杆"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
    ></van-nav-bar>
    <div class="container-item">
      <div class="add-club-btn-wrapper">
        <van-button
            class="add-club-btn"
            type="primary"
            size="large"
            icon="plus"
            @click="onAddClub"
        >
          添加新球杆
        </van-button>
      </div>

      <van-card
          shadow="never"
          class="my-card"
          v-for="club in clubList"
          :key="club.id">
        <template #desc>
          <div class="info-item serial-item">
            <div class="label-value-wrap">
              <span class="label">球杆编码:</span>
              <span class="value value_xlh">{{ club.value }}</span>
            </div>
            <van-tag class="bind-tag-red" v-if="club.bind ==='1'">待补充信息</van-tag>
            <van-tag class="bind-tag-green" v-else-if="club.bind ==='2'">已绑定</van-tag>
            <van-tag class="bind-tag-green" v-else-if="club.bind ==='3'">绑定失败</van-tag>
            <van-tag class="bind-tag-red" v-else>{{ club.bind }}</van-tag>
          </div>

          <div class="info-item">
            <span class="label">品牌:</span>
            <span class="value value_xlh">{{ club.brand }}</span>
          </div>
          <div class="info-item">
            <span class="label">系列:</span>
            <span class="value value_xlh">{{ club.model }}</span>
          </div>
          <div class="info-item">
            <span class="label">商品名称:</span>
            <span class="value value_xlh">{{ club.portalSpecs }}</span>
          </div>

          <div class="info-item  serial-item">
            <div class="label-value-wrap">
              <span class="label">销售商户:</span>
              <span class="value value_xlh">{{ club.agentName }}</span>
            </div>
          </div>
          <div class="info-item bind-tags-row">
            <van-tag class="bind-tag" color="#D4AF37" text-color="#000" v-if="club.bind ==='1'" @click="onBind(club.value )">补充信息</van-tag>
            <van-tag class="bind-tag" color="#D4AF37" text-color="#000" v-if="club.bind ==='3'" @click="onBind(club.value )">重新绑定</van-tag>
            <van-tag class="bind-tag" color="#D4AF37" text-color="#000" v-if="club.bind ==='1' || club.bind ==='2'" @click="onUnBind(club)">解绑</van-tag>
          </div>

          <div class="info-item serial-item"  v-if="club.isExist">
            <div class="label-value-wrap">
              <span class="label">会员权益:</span>
              <span class="value value_xlh">尊享会员专属权益</span>
            </div>
            <van-tag
                class="bind-tag"
                color="#D4AF37"
                text-color="#000"
                @click="onCheckRights(club)">
              查看权益
            </van-tag>
          </div>
        </template>
      </van-card>
    </div>

    <van-dialog
        v-model="unbindDialogShow"
        title="解绑球杆"
        width="90%"
        :show-cancel-button="true"
        confirm-button-text="确认"
        cancel-button-text="取消"
        :before-close="handleBeforeClose"
        :close-on-click-overlay="false"
        class="unbind-dialog"
    >
      <div class="unbind-info-wrap">
        <div class="unbind-info-item">
          <span class="unbind-label">球杆编码：</span>
          <span class="unbind-value">{{ currentClub.value }}</span>
        </div>
        <div class="unbind-info-item">
          <span class="unbind-label">品牌：</span>
          <span class="unbind-value">{{ currentClub.brand }}</span>
        </div>
        <div class="unbind-info-item">
          <span class="unbind-label">系列：</span>
          <span class="unbind-value">{{ currentClub.model }}</span>
        </div>
      </div>

      <van-field
          v-model="unbindReason"
          label="解绑原因"
          type="textarea"
          rows="4"
          required
          placeholder="请输入解绑原因"
      />
    </van-dialog>

    <van-dialog
        v-model="rightsDialogShow"
        title="会员权益详情"
        width="90%"
        show-cancel-button
        confirm-button-text="知道了"
        class="rights-dialog"
    >
      <div class="rights-content">
        <p>1. 专属售后优先处理服务</p>
        <p>2. 球杆保养维修折扣权益</p>
        <p>3. 新品优先购买资格</p>
        <p>4. 会员专属活动参与权</p>
        <p>5. 终身技术支持服务</p>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import '@/assets/css/mobileGlobal.scss';
import {benefitsByUser, userUnbindByNumber} from "@/api/sales";
import {Dialog, Tag, Button, Toast} from "vant";

export default {
  components: {
    VanTag: Tag,
    VanButton: Button
  },
  data() {
    return {
      clubList: [],
      unbindDialogShow: false,
      rightsDialogShow: false,
      currentClub: {},
      unbindReason: ''
    }
  },
  created() {
    this.selectProductByUser();
  },
  methods: {
    onAddClub() {
      this.$router.push({path: '/app_activation'});
    },

    onBind(number) {
      this.$router.push({
        path: '/app_activation',
        query: {number: number}
      });
    },

    onUnBind(club) {
      this.unbindReason = '';
      this.currentClub = {...club};
      this.unbindDialogShow = true;
    },

    onCheckRights(club) {
      this.$router.push({
        path: '/app_benefits',
        query: {
          clubValue: club.value,
          brand: club.brand,
          brandCode: club.brandCode,
          model: club.model,
          modelCode: club.modelCode,

        }
      });
    },

    async handleBeforeClose(action, done) {
      if (action === 'cancel') {
        done();
        return;
      }

      const reason = this.unbindReason.trim();
      if (!reason) {
        Toast('请输入解绑原因');
        done(false);
        return;
      }

      try {
        await Dialog.confirm({
          title: '确认解绑',
          message: `确认解绑球杆【${this.currentClub.value}】吗？`,
          closeOnClickOverlay: false
        });

        const formData = {
          keyWord: this.currentClub.value,
          opinion: reason
        };
        await userUnbindByNumber(formData);

        Toast.success(`球杆【${this.currentClub.value}】解绑成功`);
        done();
        this.selectProductByUser();

      } catch (error) {
        done(false);
        if (error.type !== 'cancel') {
          Toast.fail('解绑失败，请稍后重试');
          console.error('解绑失败：', error);
        }
      }
    },

    onClickLeft() {
      this.$router.go(-1);
    },

    selectProductByUser() {
      benefitsByUser().then(res => {
        if (res.code === 200 && res.data) {
          this.clubList = res.data;
        } else {
          if(res.returnMsg && res.returnMsg =='您当前还没有球杆'){
            this.clubList = [];
          }
          Dialog.alert({
            title: '提示',
            message: res.returnMsg || '获取数据失败',
            style: {width: '90%', maxWidth: 'none'}
          });
        }
      }).catch(err => {
        Dialog.alert({
          title: '错误',
          message: '请稍后重试',
          style: {width: '90%', maxWidth: 'none'}
        });
      })
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .van-card__content {
  @media (min-width: 768px) {
    min-height: 0;
  }
}

.h5-container {
  min-height: 100vh;
  box-sizing: border-box;
  background-color: #000;
  padding-bottom: 40px;

  @media (min-width: 768px) {
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);
    padding-bottom: 60px;
  }
}

::v-deep .van-icon-arrow-left {
  color: #0f0f0f !important;

  @media (min-width: 768px) {
    font-size: 24px;
  }
}

::v-deep .van-nav-bar__text {
  color: #0f0f0f !important;

  @media (min-width: 768px) {
    font-size: 18px;
  }
}

::v-deep .van-nav-bar__title {
  @media (min-width: 768px) {
    font-size: 22px;
    font-weight: bold;
  }
}

.top-bar {
  background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%);

  @media (min-width: 768px) {
    height: 70px;
    line-height: 70px;
  }
}

.container-item {
  margin-bottom: 60px;
  padding: 0 16px;
  box-sizing: border-box;
  width: 100%;

  @media (min-width: 768px) {
    margin-bottom: 80px;
    padding: 0 20px;
  }
}

.my-card {
  margin: 15px;
  border-radius: 12px;
  background: #fff;
  border: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  @media (min-width: 768px) {
    margin: 20px auto;
    border-radius: 16px;
    padding: 20px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    max-width: 100%;
  }

  ::v-deep .van-card__desc {
    padding: 0 !important;

    @media (min-width: 768px) {
      padding: 10px 0 !important;
    }
  }
}

.info-item {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  font-size: 15px;
  width: 100%;

  &:last-child {
    margin-bottom: 0;
  }

  .label {
    color: #0f0f0f;
    width: 80px;
    font-weight: 500;
  }

  .value {
    color: #0f0f0f;
    word-break: break-all;
  }

  @media (min-width: 768px) {
    margin-bottom: 18px;
    font-size: 18px;

    .label {
      width: 100px;
      font-size: 18px;
      font-weight: bold;
    }

    .value {
      font-size: 18px;
      line-height: 1.6;
    }
  }
}

.serial-item {
  justify-content: space-between;
  flex-wrap: nowrap;

  @media (min-width: 768px) {
    align-items: center;
    min-height: 40px;
  }
}

.label-value-wrap {
  display: flex;
  align-items: center;
  flex-shrink: 1;

  @media (min-width: 768px) {
    max-width: calc(100% - 120px);
  }
}

.bind-tags-row {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
}

.bind-tag {
  font-size: 14px;
  line-height: 20px;
  padding: 2px 6px;
  flex-shrink: 0;
  cursor: pointer;

  @media (min-width: 768px) {
    font-size: 16px;
    line-height: 24px;
    padding: 4px 12px;
    margin-left: 15px;
    border-radius: 6px;

    &:hover {
      background: #B8860B !important;
      color: #000 !important;
      transform: scale(1.05);
      transition: all 0.2s ease;
    }
  }
}

.bind-tag-red {
  font-size: 10px;
  line-height: 15px;
  padding: 2px 6px;
  margin-left: 10px;
  flex-shrink: 0;
  background: #FFFFFF;
  color: red;
  border: 1px solid red;
  border-radius: 15px;

  @media (min-width: 768px) {
    font-size: 14px;
    line-height: 20px;
    padding: 4px 10px;
    margin-left: 15px;
    border-radius: 20px;
    border-width: 2px;
  }
}

.bind-tag-green {
  font-size: 10px;
  line-height: 15px;
  padding: 2px 6px;
  margin-left: 10px;
  flex-shrink: 0;
  background: #FFFFFF;
  color: green;
  border: 1px solid green;
  border-radius: 15px;

  @media (min-width: 768px) {
    font-size: 14px;
    line-height: 20px;
    padding: 4px 10px;
    margin-left: 15px;
    border-radius: 20px;
    border-width: 2px;
  }
}

.add-club-btn-wrapper {
  margin: 15px 15px 15px;
  text-align: center;

  @media (min-width: 768px) {
    margin: 40px 20px 20px;
  }
}

.add-club-btn {
  background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%);
  border: none;
  border-radius: 12px;
  font-size: 16px;
  height: 48px;
  line-height: 48px;
  width: 100%;

  @media (min-width: 768px) {
    font-size: 18px;
    height: 56px;
    line-height: 56px;
    border-radius: 16px;
    max-width: 500px;
    transition: all 0.2s ease;

    &:hover {
      transform: scale(1.02);
      box-shadow: 0 4px 16px rgba(212, 175, 55, 0.4);
    }
  }

  ::v-deep &.van-button--primary {
    background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%) !important;
  }
}

::v-deep .unbind-dialog {
  .van-dialog__content {
    padding: 20px;
  }

  @media (min-width: 768px) {
    width: 600px !important;
    max-width: 600px;

    .van-dialog__header {
      padding: 12px 20px 8px;
      border-bottom: 1px solid #f5f5f5;
      height: auto;

      .van-dialog__title {
        font-size: 18px;
        font-weight: bold;
        color: #333;
        line-height: 1.2;
      }
    }

    .van-dialog__content {
      padding: 16px 20px;
      min-height: auto;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }

    .van-dialog__footer {
      padding: 12px 20px 16px;
      border-top: 1px solid #f5f5f5;

      .van-button {
        height: 40px;
        padding: 0 24px;
        font-size: 16px;
        border-radius: 8px;
      }
    }
  }
}

.unbind-info-wrap {
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #eee;

  .unbind-info-item {
    display: flex;
    margin-bottom: 10px;
    font-size: 15px;
    align-items: center;

    .unbind-label {
      color: #666;
      min-width: 80px;
      font-weight: 500;
    }

    .unbind-value {
      color: #333;
      flex: 1;
      word-break: break-all;
      font-weight: 500;
    }

    @media (min-width: 768px) {
      margin-bottom: 12px;
      font-size: 16px;

      .unbind-label {
        min-width: 90px;
        font-size: 16px;
        color: #555;
      }

      .unbind-value {
        font-size: 16px;
        color: #222;
      }
    }
  }
}

.unbind-reason-field {
  ::v-deep .van-field__label {
    font-size: 15px;
    color: #666;
    width: 80px;
  }

  ::v-deep .van-field__control {
    font-size: 15px;
    min-height: auto;
  }

  @media (min-width: 768px) {
    ::v-deep .van-field__label {
      font-size: 16px;
      width: 90px;
      color: #555;
      font-weight: 500;
    }

    ::v-deep .van-field__control {
      font-size: 16px;
      min-height: auto;
      max-height: none;
      padding: 8px 12px;
      border-radius: 6px;
      border: 1px solid #e5e5e5;
    }

    ::v-deep .van-field__placeholder {
      font-size: 15px;
      color: #999;
    }
  }
}

::v-deep .rights-dialog {
  .van-dialog__content {
    padding: 20px;
  }
  @media (min-width: 768px) {
    width: 500px !important;
    .van-dialog__header {
      padding: 12px 20px 8px;
    }
    .van-dialog__content {
      padding: 16px 20px;
    }
  }
}
.rights-content {
  line-height: 2;
  font-size: 15px;
  p {
    margin: 8px 0;
    padding: 0;
  }
  @media (min-width: 768px) {
    font-size: 16px;
    p {
      margin: 10px 0;
    }
  }
}

@media (min-width: 768px) {
  ::v-deep .van-dialog {
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  }
}
</style>